<template>
    <step-wrapper>
        <step-heading class="
          flex items-center justify-between px-[24px] pt-[24px]

          sm:px-0
        ">
            {{ $t('CUSTOM_ICONS') }}
            <button
                class="rounded text-[14px] font-normal uppercase underline focus-outline-only"
                @click="clearPlacement('DesignLogo')"
            >
                {{ $t('CLEAR') }}
            </button>
        </step-heading>

        <div
            v-for="iconCategory in iconsByCategory"
            :key="iconCategory.category"
            class="
              flex w-full flex-col px-[24px] pb-8

              sm:px-0
            "
        >
            <step-section-heading class="flex items-center justify-between">
                {{ iconCategory.category }}
            </step-section-heading>

            <div class="
              grid min-h-[120px] w-full grid-cols-3 gap-4

              md:grid-cols-4
            "
                v-auto-animate
            >
                <primary-button
                    v-for="icon in displayedIcons(iconCategory)"
                    :key="icon.icon"
                    class="aspect-square"
                    :is-active="icon.icon === selectedIcon"
                    selected-style="outline"
                    :button="icon"
                    :aria-label="icon.name"
                    @click="selectIcon(icon)"
                    :is-square="true"
                    :show-text-badge="icon.hasTextEditAvailable"
                >
                    <span class="absolute inset-2 bg-contain bg-center bg-no-repeat"
                        :style="{
                            backgroundImage: `url(&quot;${previewImage(icon)}&quot;)`,
                        }"
                    >
                    </span>
                </primary-button>
                <button
                    v-if="iconCategory.icons.length > 7"
                    class="aspect-square rounded text-sm underline focus-outline-only"
                    @click="toggleCategory(iconCategory.category)"
                >
                    {{ isExpanded[iconCategory.category] ? $t('VIEW_LESS') : $t('VIEW_MORE') }}
                </button>
            </div>
        </div>
    </step-wrapper>
</template>

<script>
    import StepHeading from '../UI/headings/StepHeading.vue';
    import StepSectionHeading from '../UI/headings/StepSectionHeading.vue';
    import PrimaryButton from '../UI/buttons/PrimaryButton.vue';
    import StepWrapper from '../wrappers/StepWrapper.vue';

    import allStores from '../../stores/all';

    export default {
        mixins: [allStores],

        components: {
            StepHeading,
            StepSectionHeading,
            PrimaryButton,
            StepWrapper,
        },

        data() {
            return {
                selectedIcon: '',
                isExpanded: {},
            };
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            iconsByCategory() {
                return this.customizerStore.iconsByCategory;
            },
        },

        mounted() {
            this.selectedIcon = this.viewController.selectedAtPlacement('DesignLogo')?.custom?.['dynamic-image-gallery'];
        },

        methods: {
            clearPlacement(placementCode) {
                this.customizerStore.clearPlacement(placementCode);
                this.customizerStore.clearIcon(placementCode);

                this.selectedIcon = '';
            },

            selectIcon(icon) {
                this.selectedIcon = icon.icon;
                this.customizerStore.selectIcon(icon.icon);
            },

            previewImage(icon) {
                if (icon.iconImage) {
                    return icon.iconImage;
                }

                return icon.image;
            },

            toggleCategory(category) {
                this.isExpanded[category] = !this.isExpanded[category];
            },

            displayedIcons(iconCategory) {
                if (this.isExpanded[iconCategory.category] || iconCategory.icons.length <= 7) {
                    return iconCategory.icons;
                }

                return iconCategory.icons.slice(0, 7);
            },
        },
    };
</script>
